// extracted by mini-css-extract-plugin
module.exports = {"drawer-root":"Drawer_drawer-root__2SMcv","drawer-content":"Drawer_drawer-content__GezB7","group":"Drawer_group__Y3e1x"};